<!--
 * @Date: 2022-08-04 16:29:35
 * @LastEditors: StavinLi
 * @LastEditTime: 2022-09-21 11:25:18
 * @FilePath: /Workflow/src/components/dialog/roleDialog.vue
-->
<template>
  <Modal
    title="选择角色"
    v-model="visibleDialog"
    width="800px"
    transfer
    class="promoter_role"
    :mask-closable="false"
  >
    <roleSelect
      ref="roleSelect"
      :list.sync="list"
      :searchUseSelect="searchUseSelect"
      :multiple="true"
      :selectList.sync="selectList"
      :selectedIds.sync="selectedIds"
      :selectGroupIds.sync="selectGroupIds"
      :originData="originData"
      :customTreeList.sync="customTreeList"
      @on-select-change="onRoleSelectChange"
    />
    <span slot="footer" class="dialog-footer">
      <Button @click="$emit('update:visible', false)">取 消</Button>
      <Button type="primary" @click="saveDialog">确 定</Button>
    </span>
  </Modal>
</template>

<script>
import { roleSelect } from '../dialogInfo';
import { getDepartmentSelect } from '@/api/workflow';
import mixins from './mixins';
export default {
  components: { roleSelect },
  mixins: [mixins],
  props: ['visible', 'selected'],
  watch: {
    visible(val) {
      this.visibleDialog = this.visible;
      if (val) {
        this.getDepartmentOptions();
      }
    },
    visibleDialog(val) {
      this.$emit('update:visible', val);
    }
  },
  computed: {},
  data() {
    return {
      visibleDialog: false,
      checkedRoleList: [],
      list: [],
      selectList: [],
      selectedIds: [],
      selectGroupIds: [],
      originData: [],
      customTreeList: [],
      searchUseSelect: []
    };
  },
  methods: {
    saveDialog() {
      this.$emit('change', this.selectList);
    },
    delList() {
      this.checkedRoleList = [];
    },
    async getDepartmentOptions() {
      const res = await getDepartmentSelect();
      const { code, data } = res.data;
      if (code == 200) {
        if (Array.isArray(data) && data.length > 0) {
          this.searchUseSelect = data;
          // 在这里设置selected
          /**
           * 逻辑
           *  如果在获取到的新的列表里面，部门id不存在的话，会清空当前选择的角色，但是只是显示清空了，如果不去保存的话，还是不变
           *  如果部门id存在的话，就把当前的id给拿到，当作第一个选中的第一个
           */
          const checkSelected = this.selected || [];
          const hasDepartmentIdObj = checkSelected.find(
            item => item.departmentId
          );
          let departmentId = (data[0] || {}).id,
            selectedData = this.selected;
          if (this.selected.length > 0 && hasDepartmentIdObj) {
            departmentId = hasDepartmentIdObj.departmentId;
          }
          const hasId = data.find(item => item.id == departmentId);
          if (!hasId) {
            selectedData = [];
            departmentId = (data[0] || {}).id;
          }
          const roleSelectDom = this.$refs['roleSelect'];
          roleSelectDom.selectModel = departmentId;
          this.getRoleList({ id: departmentId, selected: selectedData });
        }
      }
    },
    onRoleSelectChange(id) {
      this.selectList = [];
      this.getRoleList({ id, selected: this.selectList });
    }
  }
};
</script>

<style>
@import '../../../../assets/styles/common/dialog.css';
</style>
